import type { ICampaignGroup } from '~/modules/campaign-group/types';
import type { Campaign } from '~/modules/campaign/types';

import { areObjectsDifferent, hasUnorderedArrayFieldChanges } from '~/modules/campaign-template';

export const CG_UNORDERED_ARRAY_FIELDS: (keyof ICampaignGroup)[] = [
  'targetChannels',
  'targetCountries',
  'targetDevices',
  'targetVisitorTypes',
];

const UNORDERED_ARRAY_CONDITION_FIELDS: (keyof NonNullable<Campaign['conditions']>)[] = [
  'targetMarkets',
  'targetPageIds',
];

export const CG_DISCARD_EXCLUDE_KEYS = [
  'updatedAt',
  'createdAt',
  'startedAt',
  'pausedAt',
  'completedAt',
  'name',
  'status',
  'versions',
  'storeDomain',
  'campaigns',
  'conditions',
  ...CG_UNORDERED_ARRAY_FIELDS,
];

const checkCampaignConditions = (
  campaign: ICampaignGroup,
  campaignCheck: ICampaignGroup,
): boolean => {
  if (
    areObjectsDifferent(
      campaign.conditions ?? {},
      campaignCheck.conditions ?? {},
      UNORDERED_ARRAY_CONDITION_FIELDS,
    )
  )
    return true;

  return hasUnorderedArrayFieldChanges(
    campaign.conditions ?? {},
    campaignCheck.conditions ?? {},
    UNORDERED_ARRAY_CONDITION_FIELDS,
  );
};

export const isCampaignGroupDifferent = (
  campaign: ICampaignGroup,
  campaignCheck: ICampaignGroup,
): boolean => {
  if (areObjectsDifferent(campaign, campaignCheck, CG_DISCARD_EXCLUDE_KEYS)) return true;

  if (hasUnorderedArrayFieldChanges(campaign, campaignCheck, CG_UNORDERED_ARRAY_FIELDS))
    return true;

  if (checkCampaignConditions(campaign, campaignCheck)) return true;

  return false;
};
